// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__24mEX","rootSmall":"AddTileButton_rootSmall__1_1dw"};